import React, { Component } from "react";
import styled from "styled-components";

const RoundedSectionContainer = styled.section`
	background-color: #fff;
	border-radius: 25px;
	box-sizing: border-box;
	color: #000;
	font-size: 30px;
	margin: 10px 0;
	overflow: hidden;
	padding: 25px;
	text-align: center;
	width: 100%;
`;

type Props = {
	padding: string,
	style: any,
	children: any,
};
type State = {};
class RoundedSection extends Component<Props, State> {
	render(props) {
		let padding = this.props.padding || "25px";

		return (
			<RoundedSectionContainer
				className={this.props.className}
				style={{ padding: padding, borderRadius: padding, ...this.props.style }}
			>
				{this.props.children}
			</RoundedSectionContainer>
		);
	}
}

export default RoundedSection;



// WEBPACK FOOTER //
// ../shared/components/RoundedSection.js